import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

// scoped rather than a global `.spinner` class, so dropping this into a shared library
// cannot collide with page CSS
const Spinner = styled.span`
  animation: ${spin} 400ms linear infinite;
  border-radius: 50%;
  border: ${props => Math.max(2, Math.round(Math.sqrt(props.size) / 2))}px solid #ccc;
  border-right-color: #333;
  box-sizing: border-box;
  display: inline-block;
  height: ${props => props.size}px;
  width: ${props => props.size}px;
`;

Spinner.defaultProps = {
  size: 20,
};

Spinner.propTypes = {
  size: PropTypes.number,
};

export default Spinner;
